import React, { useState, useEffect } from 'react';
import api from 'api';
import HeroContentType from 'containers/user/learn/components/hero-content-type/hero-content-type';
import NothingFound from 'containers/user/learn/components/empty-row/empty-row';
import { useCurrentUser } from 'hooks/api/use-current-user';
import Cards from 'containers/user/learn/components/cards/cards';

import { Box } from 'ui/box';
import { Stack } from 'ui/stack';

import { Loader } from 'ui/loader';
import SeeMoreButton from 'containers/user/learn/components/see-more-btn/see-more-btn';

interface WebinarCardItem {
  name?: string;
  route: string;
  coverDescription?: string;
  date?: string;
  coverImage?: string;
}

interface WebinarApiEntry {
  id: string | number;
  attributes?: {
    name?: string;
    coverDescription?: string;
    coverImage?: { data?: { attributes?: { url?: string } } };
    webinarDate?: string;
  };
}

const Webinars = (): React.JSX.Element => {
  const [webinars, setWebinars] = useState<WebinarCardItem[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [displayAll, setDisplayAll] = useState<boolean>(false);

  const user = useCurrentUser();

  useEffect(() => {
    setLoading(true);
    api
      .getWebinars(user?.data?.oktaUserId ?? '')
      .then((res) => {
        const data = (res as { data?: { data?: WebinarApiEntry[] } })?.data
          ?.data;

        setWebinars(
          data?.map((el) => ({
            name: el.attributes?.name,
            route: `/learn/content/webinars/${el.id}`,
            coverDescription: el.attributes?.coverDescription,
            date: el.attributes?.webinarDate,
            coverImage: el.attributes?.coverImage?.data?.attributes?.url,
          })) ?? []
        );
      })
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  const displayedWebinars =
    displayAll || webinars.length < 10 ? webinars : webinars.slice(0, 9);

  return (
    <Box sx={{ width: '100%' }}>
      <Loader loading={loading} />
      <HeroContentType
        title="Webinars"
        description="View recordings of MARKETview webinars featuring perspectives from higher ed experts and practitioners on a variety of topics impacting institutions today."
        breadcrumbs={[
          { label: 'Learn', href: '/learn' },
          { label: 'Webinars', isActive: true },
        ]}
        customClass="pt-5"
      />
      <Stack sx={{ alignItems: 'center', mt: 5 }}>
        {!displayedWebinars.length && !loading ? (
          <NothingFound contentType="webinars" />
        ) : (
          <Cards items={displayedWebinars} contentType="Webinar" />
        )}
        {webinars.length > 9 && (
          <SeeMoreButton
            onClick={() => setDisplayAll(!displayAll)}
            showAll={displayAll}
          />
        )}
      </Stack>
    </Box>
  );
};

export default Webinars;
